import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import './Hero.css';

// @TODO: hard coded content which will need to be refactored for CMS integration
const Hero = (isDesktop) => {
    return (
        <section className="hero">
            <div className='hero-body'>
                <div className="container">
                    <div className="columns is-mobile">
                        <div className="column is-12-mobile is-10-tablet is-offset-1-tablet is-9-desktop is-8-widescreen">
                            <div className="upper-block-wrapper">
                                <div className="title-wrapper animated fadeInLeft">
                                    <h1 className="hidden">Hudson Pacific Properties Careers</h1>
                                    <div className="pre-title">Careers</div>
                                    <div className="big-title">
                                    WHERE WE WORK SHAPES<br/> WHO WE ARE—AND HOW<br/> WE THRIVE<br/>
                                    </div>
                                    <Link className="button" to="/careers/positions">
                                        <span>Open Positions</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="columns">
                        <div className="column has-text-right triangleHolder">
                            <div className="lower-block-wrapper">
                                <div className="big-title">
                                    Life at <br />
                                    Hudson Pacific
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="background-wrapper">
                    <div className="blur-container">
                        <div className="blur-effect">
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

Hero.propTypes = {
    isDesktop: PropTypes.bool,
};

export default Hero;
